import { FormSelect } from '@shared/ui/Form/FormSelect';
import type { ComponentProps } from 'react';

type VacancyResponsibleUserProps = Omit<
  ComponentProps<typeof FormSelect>,
  'title' | 'description' | 'placeholder'
>;

export const VacancyResponsibleUser = ({
  ...props
}: VacancyResponsibleUserProps) => {
  return (
    <FormSelect
      {...props}
      title='Ответственный сотрудник'
      description='Выберите ответственного сотрудника компании-нанимателя'
      placeholder='Выберите'
    />
  );
};
